<template>
<div class="shaker"></div>
</template>

<script>
export default {
  name: 'shaker'
}
</script>

<style lang="scss">
@keyframes shaker {
  0% {
    transform: rotate3d(0,0,1,-25deg);
  }
  50% {
    transform: rotate3d(0,0,1,0deg);
  }
  100% {
    transform: rotate3d(0,0,1,-25deg);
  }
}
.shaker {
  position: relative;
  width: fluid(100px);
  height: fluid(96px);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  background-image: url('~@/assets/img/shaker.svg');
  transform-origin: 30% 70%;
  transform: rotate3d(0,0,1,-25deg);
}
.shaking {
  .shaker {
    animation: shaker 0.5s linear infinite;
  }
}
</style>